export const exportCSV = (header, dataRows, name) => {
  const csvContent = [header, ...dataRows].join('\n');
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export const exportCSVFromDataGrid = _ref => {
  let columns = _ref.columns,
    name = _ref.name,
    rows = _ref.rows;
  // Get visible and exportable columns
  const visibleColumns = columns.filter(col => col.isExportable);
  // Build header row
  const header = visibleColumns.map(col => typeof col.headerName === 'string' ? col.headerName.replace(/\n/g, ' ') : col.headerName).join(',');
  // Build data rows
  const dataRows = rows.map(row => {
    return visibleColumns.map(col => {
      // Use renderCell logic
      if (col.renderCell) {
        // Try to mimic renderCell output
        // For most, just use the valueGetter or field
        if (col.valueGetterForExport) {
          const value = col.valueGetterForExport({
            row
          });
          return typeof value === 'string' ? value.replace(/,/g, ' ') : value;
        } else if (col.valueGetter) {
          const value = col.valueGetter({
            row
          });
          return typeof value === 'string' ? value.replace(/,/g, ' ') : value;
        } else if (row[col.field] !== undefined) {
          return typeof row[col.field] === 'string' ? row[col.field].replace(/,/g, ' ') : row[col.field];
        } else {
          return 'N/A';
        }
      } else {
        return row[col.field] !== undefined ? row[col.field] : 'N/A';
      }
    }).join(',');
  });
  exportCSV(header, dataRows, name);
};